module.exports = __webpack_public_path__ + "static/media/Mapa.edde8ac3.png";